import type { RsvpStatus } from "./types";

export const MAX_ADDITIONAL_GUESTS = 3;

export function guestNames(value: unknown, count: number): string[] {
  if (!Array.isArray(value) || value.length !== count || value.some((name) => typeof name !== "string" || !name.trim() || name.trim().length > 120)) {
    throw new Error("Enter a full name for each additional guest (maximum 120 characters).");
  }
  return value.map((name: string) => name.trim());
}

export function validGuestCount(value: unknown): value is number {
  return typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= MAX_ADDITIONAL_GUESTS;
}

export function importedGuestCount(value: unknown, fallback = 0): number {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value === "string" && !/^\d+$/.test(value.trim())) throw new Error("Additional Guests must be a whole number from 0 to 3.");
  const count = typeof value === "string" ? Number(value.trim()) : value;
  if (!validGuestCount(count)) throw new Error("Additional Guests must be a whole number from 0 to 3.");
  return count;
}

export function attendeeCount(status: RsvpStatus, active: boolean | number, additionalGuests: number): number {
  return active && status === "confirmed" ? 1 + additionalGuests : 0;
}
